import { apiRequest } from "api";
import { getDecryptedResponse } from "api/decrypt";
import { BASE_URL } from "constants/routes";
import CryptoJS from "crypto-js";

let decryptedTokenId = null;

async function generateToken() {
  const reqUri = `${BASE_URL}/workflow/generateToken`;
  const option = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const result = await apiRequest(reqUri, option);
    const { status, message, token_generated } = result;
    if (status === "success" && token_generated) {
      decryptedTokenId = CryptoJS.AES.decrypt(
        token_generated,
        "Q5mo=2WMXKAwmTkbwBlftGd6LVZjVKXh"
      ).toString(CryptoJS.enc.Utf8);
    }
  } catch (err) {
    // console.log("Request error:", err);
  }
}

/**
 * It Performs an API request with an optional payload encryption and access token handling.
 *
 * This function handles the  API requests with an optional payload encryption and access token inclusion.
 * Depending on the encryption and decryption requirements, it processes the provided payload and performs
 * the API request while managing tokens if required.
 *
 * @param {string} url - The URL for the API endpoint.
 * @param {object} options - Options for the API request (e.g., method, headers, body).
 * @param {boolean} encrypt - Indicates whether payload encryption is needed.
 * @param {boolean} encryptedBodyRes - Indicates whether an encrypted response body is expected.
 * @param {boolean} requiredAccessToken - Indicates whether an access token is required for the request.
 * @returns {Promise<object>} - A Promise resolving to the API response, encrypted parameters, or decrypted response.
 * @throws Throws an error if any issue occurs during the API request, token management, or encryption.
 */
export async function encryptPayload(
  url = "",
  options = { body: {} },
  encrypt,
  encryptedBodyRes,
  requiredAccessToken = false
) {
  if (encrypt && encryptedBodyRes) {
    if (!decryptedTokenId) {
      await generateToken();
    }
    const encryptedBody = CryptoJS.AES.encrypt(
      JSON.stringify(options.body),
      decryptedTokenId
    ).toString();
    const encryptedTokenId = btoa(decryptedTokenId);
    const encryptedAPIParams = {
      api_body: encryptedBody,
      token_id: encryptedTokenId,
    };
    const _options = { ...options, body: JSON.stringify(encryptedAPIParams) };
    if (encryptedBodyRes) {
      return { ...encryptedAPIParams, decrypt: true };
    }
    return apiRequest(url, _options,requiredAccessToken);
  }

  if (encrypt && !encryptedBodyRes) {
    if (!decryptedTokenId) {
      await generateToken();
    }
    const encryptedTokenId = btoa(decryptedTokenId);
    const encryptedAPIParams = {
      token_id: encryptedTokenId,
      decrypt: true,
    };
    return encryptedAPIParams;
  }

  if (!encrypt && encryptedBodyRes) {
    const { data, status, message } = await apiRequest(url, options,requiredAccessToken);
    const response = data?.token_id ? await getDecryptedResponse(data) : "{}";
    return {
      status,
      data: JSON.parse(response)?.responseData ? JSON.parse(response)?.responseData : JSON.parse(response),
      message,
    };
  }

  return apiRequest(url, options,requiredAccessToken);
}
